<template>
  <v-container id="paymentsreceived" fluid tag="section">
    <div class="text-right">
      <v-btn color="cyan" @click="showFilter = !showFilter" small>
        <v-icon>mdi-filter</v-icon>
      </v-btn>
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" color="light-blue" small>
            <h3>
              {{ $i18n.t("Action") }}
              <v-icon>mdi-menu-down</v-icon>
            </h3>
          </v-btn>
        </template>
        <v-list>
          <v-list-item :to="'/paymentreceived/create'">
            <v-icon>mdi-plus</v-icon>
            <v-list-item-title>{{ $i18n.t("Add New") }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>

    <v-row justify="center" v-if="showFilter">
      <v-col cols="12" md="12">
        <base-material-card
          color="light-blue"
          icon="mdi-filter"
          class="px-3 py-1 small-icon"
          v-if="showFilter"
        >
          <div class="filter-close">
            <v-btn
              color="black"
              class="mr-0"
              fab
              small
              text
              @click="showFilter = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
          <v-row>
            <v-col cols="12" sm="12" md="4" lg="3">
              <z-client-select withSelf clearable v-model="filters.client_id" />
            </v-col>
            <v-col cols="12" sm="12" md="4" lg="3">
              <z-date-picker
                :label="$i18n.t('From Date')"
                v-model="filters.fromDate"
              />
            </v-col>
            <v-col cols="12" sm="12" md="4" lg="3">
              <z-date-picker
                :label="$i18n.t('Till Date')"
                v-model="filters.tillDate"
              />
            </v-col>

            <v-col cols="12" sm="12" md="4" lg="3">
              <v-text-field
                :label="$i18n.t('Transaction ID')"
                v-model="filters.transID"
                clearable
              />
            </v-col>

            <v-col cols="12" sm="12" md="4" lg="3" class="text-right">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    class="mr-0"
                    color="grey darken"
                    fab
                    text
                    small
                    @click="clear(1)"
                    style="margin-right: 10px !important"
                    v-on="on"
                  >
                    <v-icon>mdi-cached</v-icon>
                  </v-btn>
                </template>
                <span>{{ $i18n.t("Clear Filter") }}</span>
              </v-tooltip>
              <v-btn
                color="success"
                class="mr-0"
                fab
                small
                dark
                @click="search()"
                :loading="loading"
              >
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
              <v-btn
                color="orange"
                class="mr-0"
                fab
                small
                dark
                @click="downloadAll()"
                :loading="loading"
              >
                <v-icon>mdi-cloud-download</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </base-material-card>
      </v-col>
    </v-row>

    <v-btn
      v-if="grid != undefined && !grid.records"
      class="text-center secondary--text pa-10"
      text
      color="primary"
      style="width: 100%"
      :loading="loading"
      >{{ $i18n.t("No records available") }}</v-btn
    >

    <base-material-card
      icon="mdi-card-text-outline"
      :title="$i18n.t('Payments Done')"
      class="px-5 py-3 small-icon"
      v-if="grid.records"
    >
      <z-grid-record :grid="grid" />

      <v-simple-table dense>
        <template v-slot:default>
          <thead class="thead">
            <tr>
              <th class="text-left">
                {{ $i18n.t("Client") }}
              </th>
              <th class="text-left">
                {{ $i18n.t("Client Entity") }}
              </th>
              <th class="text-left">
                {{ $i18n.t("Date") }}
              </th>
              <th class="text-left">
                {{ $i18n.t("Transaction ID") }}
              </th>
              <th class="text-left">
                {{ $i18n.t("Amount Received") }}
              </th>
              <th class="text-left">
                {{ $i18n.t("TDS") }}
              </th>
              <th class="text-left" title="Extra amount to which this payment is carry forwarded to next payment">
                {{ $i18n.t("Carry Forwarded To") }}
              </th>
              <th class="text-left" title="Extra amount from which previous payment is carry forwarded to this payment">
                {{ $i18n.t("Carry Forwarded From") }}
              </th>
              <th class="text-right">{{ $i18n.t("Action") }}</th>
            </tr>
          </thead>
          <payments-received-row
            v-for="item in grid.rows"
            :key="item._id"
            :value="item"
            @refresh="refresh"
          />
        </template>
      </v-simple-table>

      <v-container>
        <v-pagination
          v-model="grid.page"
          class="my-4"
          :length="grid.total"
          total-visible="10"
          @input="showPage"
        ></v-pagination>
      </v-container>
    </base-material-card>
  </v-container>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import { doGet } from "@/store/common/module/apis";
import common from "@/store/common/module/common";
import PaymentsReceivedRow from "@/views/paymentreceived/PaymentsReceivedRow.vue";

@Component({
  name: "PaymentsReceived",
  components: { PaymentsReceivedRow },
})
export default class PaymentsReceived extends Vue {
  grid = { page: 0, rows: [] };
  url = "/api/collectible/grid?&";
  showFilter = false;
  filterUrl = "";
  on = null;
  page = 1;
  rows = 50;

  filters = {
    client_id: null,
    fromDate: null,
    tillDate: null,
    transID: null,
  };

  get loading() {
    return common.loading;
  }

  get gridHeight() {
    return this.windowHeight > 500 ? this.windowHeight - 150 : 300;
  }

  get itemHeight() {
    return this.windowWidth > 960 ? 75 : 240;
  }

  async mounted() {
    this.showPage(1);
  }

  async showPage(page) {
    common.setLoading(true);
    this.page = page;
    try {
      const grid = await doGet(
        this.url + "rows=" + this.rows + "&page=" + page + this.filterUrl
      );
      if (grid.rows && grid.rows.length > 0) {
        // for (let i = 0; i < grid.rows.length; i++) {
        //   grid.rows[i].selected = false;
        //   grid.rows[i]._showAssign = false;
        // }
      }
      this.grid = grid;
    } catch (e) {
      common.setError(e.message);
    }
    common.setLoading(false);
  }

  async clear() {
    this.filters = {};
    this.page = 1;
    this.search();
  }

  async refresh(__i) {
    if (__i == 1) {
      this.search();
    }
  }

  async search() {
    this.filterUrl = "";
    if (this.filters.client_id)
      this.filterUrl += "&client_id=" + this.filters.client_id;
    if (this.filters.fromDate)
      this.filterUrl += "&fromDate=" + this.filters.fromDate;
    if (this.filters.tillDate)
      this.filterUrl += "&tillDate=" + this.filters.tillDate;
    if (this.filters.transID)
      this.filterUrl += "&transID=" + this.filters.transID;
    common.setLoading(true);
    await this.showPage(1);
  }

  isSet(_key) {
    if (
      _key != null &&
      _key != undefined &&
      _key != "null" &&
      _key != "undefined" &&
      _key != ""
    ) {
      return true;
    }
    return false;
  }

  async reload() {
    this.showPage(this.page);
  }
  makeFilterUrl() {
    this.filterUrl = "";
    if (this.filters.client_id)
      this.filterUrl += "&client_id=" + this.filters.client_id;
    if (this.filters.fromDate)
      this.filterUrl += "&fromDate=" + this.filters.fromDate;
    if (this.filters.tillDate)
      this.filterUrl += "&tillDate=" + this.filters.tillDate;
    if (this.filters.transID)
      this.filterUrl += "&transID=" + this.filters.transID;
  }

  async downloadAll() {
    let url = "/api/collectible/download?_search=true";
    this.makeFilterUrl();
    url = url + this.filterUrl;
    window.open(url, "_blank");
  }
}
</script>

<style scoped>
.filter-close {
  position: absolute;
  right: 5px;
  top: 5px;
}
.dialog {
  position: fixed;
  top: 100px;
  width: 60%;
  z-index: 10;
  margin-left: 15%;
}
.sticky-bottom {
  position: sticky;
  bottom: 0;
  background-color: white;
  border-top: 1px solid #dfdfdf;
}
.sticky-top {
  position: sticky;
  top: 0;
  z-index: 2;
}
tbody:nth-child(even) {
  background: #fafafa;
}
.thead tr th {
  padding: 0 2px !important;
}
</style>
